import React, { Component } from 'react';
import { APP_CONFIG } from './../../boot.config';
// import { nextStorage } from './../../util/nextStorage';

import { PanelContent } from './../../components/Global/PanelContent/PanelContent';
export class Shop_HomeContainer extends Component{
  constructor(props){
    super(props);
    this.state = {
      isLoading: true,
      currentUser: null,
      id: null,
      products: [
        {
          productID: 0,
          title: 'Produto Model',
          category: 'Default',
          shortDescription: 'Bla bla bla productShortDescription',
          productQty: 2,
          price: '10,11'
        },
        {
          productID: 1,
          title: 'Produto Model',
          category: 'Default',
          shortDescription: 'Bla bla bla productShortDescription',
          productQty: 2,
          price: '10,11'
        },
        {
          productID: 2,
          title: 'Produto Model',
          category: 'Default',
          shortDescription: 'Bla bla bla productShortDescription',
          productQty: 2,
          price: '10,11'
        },
        {
          productID: 3,
          title: 'Produto Model',
          category: 'Default',
          shortDescription: 'Bla bla bla productShortDescription',
          productQty: 2,
          price: '10,11'
        },
        {
          productID: 4,
          title: 'Produto Model',
          category: 'Default',
          shortDescription: 'Bla bla bla productShortDescription',
          productQty: 2,
          price: '10,11'
        },
        {
          productID: 5,
          title: 'Produto Model',
          category: 'Default',
          shortDescription: 'Bla bla bla productShortDescription',
          productQty: 2,
          price: '10,11'
        },
        {
          productID: 6,
          title: 'Produto Model',
          category: 'Default',
          shortDescription: 'Bla bla bla productShortDescription',
          productQty: 2,
          price: '10,11'
        }
      ]
      // productsList: [{
      //   productID: 0,
      //   productTitle: 'Produto Model',
      //   productCategory: 'Default',
      //   productShortDescription: 'Bla bla bla productShortDescription',
      //   productQty: 2,
      //   productPrice: '10.11'
      // }]
    }
    document.title = APP_CONFIG.PROJECT_NAME;

    this.renderView = this.renderView.bind(this);
  }

  componentDidMount(){
    document.title = APP_CONFIG.PROJECT_NAME + ' | ' + APP_CONFIG.PROJECT_SLOGAN;
  }

  renderView(){
    return (
      <PanelContent
        panelType={'ShopProductGrid'}
        where={'shop'}
        currentUser={null}
        action={null}
        pageID={null}
        propsExtra={this.state.products}
        buttonsAction={null}
        />
    );
  }

  render(){
    return this.renderView()
  }
}



// WEBPACK FOOTER //
// ./src/app/containers/Shop/Shop_HomeContainer.js